module.exports = __webpack_public_path__ + "img/404.e0646466.png";